import * as THREE from "three";
import { PersonData } from "../types";

const DEG2RAD = Math.PI / 180;

export function createPerson(data: PersonData): THREE.Group {
  const person = new THREE.Group();

  const skinMat = new THREE.MeshStandardMaterial({
    color: 0xd4a574,
    roughness: 0.8,
  });
  const clothMat = new THREE.MeshStandardMaterial({
    color: 0x445566,
    roughness: 0.75,
  });

  const headGeo = new THREE.SphereGeometry(0.15, 10, 8);
  const head = new THREE.Mesh(headGeo, skinMat);
  head.position.y = 1.55;
  head.castShadow = true;
  person.add(head);

  const torsoGeo = new THREE.CylinderGeometry(0.12, 0.15, 0.6, 8);
  const torso = new THREE.Mesh(torsoGeo, clothMat);
  torso.position.y = 1.1;
  torso.castShadow = true;
  person.add(torso);

  const legGeo = new THREE.CylinderGeometry(0.07, 0.07, 0.65, 6);
  const leftLeg = new THREE.Mesh(legGeo, clothMat);
  leftLeg.position.set(0.06, 0.5, 0);
  leftLeg.castShadow = true;
  person.add(leftLeg);

  const rightLeg = new THREE.Mesh(legGeo, clothMat);
  rightLeg.position.set(-0.06, 0.5, 0);
  rightLeg.castShadow = true;
  person.add(rightLeg);

  person.position.set(...data.position);
  person.rotation.set(
    data.rotation[0] * DEG2RAD,
    data.rotation[1] * DEG2RAD,
    data.rotation[2] * DEG2RAD
  );

  return person;
}
